import { useFilters } from "../../../data/useFilters";
import {
  AutocompleteContainer,
  SuggestionContainer,
  SuggestionItem,
  SuggestionsDivider,
  SuggestionSearchIcon,
} from "./styles";

const Autocomplete = ({ isFocused, onSearch, suggestedTerms }) => {
  const { anchorsApplied } = useFilters();

  if (!suggestedTerms?.length) return <></>;

  const termsToSearch = suggestedTerms.filter(
    ({ action }) => action === "suggest"
  );
  const termsToRedirect = suggestedTerms.filter(
    ({ action }) => action === "redirect"
  );

  return (
    <AutocompleteContainer
      className="bn-search__autocomplete-container"
      isFocused={isFocused}
      isAnchored={anchorsApplied?.length}
    >
      {termsToSearch.length > 0 && (
        <SuggestionContainer role="listbox">
          {termsToSearch.map(({ label, value }) => (
            <SuggestionItem
              key={crypto.randomUUID()}
              role="option"
              onClick={() => onSearch(value)}
            >
              <SuggestionSearchIcon type="button" />
              <span>{label}</span>
            </SuggestionItem>
          ))}
        </SuggestionContainer>
      )}

      {termsToSearch.length > 0 && termsToRedirect.length > 0 && (
        <SuggestionsDivider />
      )}

      {termsToRedirect.length > 0 && (
        <SuggestionContainer role="listbox">
          {termsToRedirect.map(({ highlights, value }) => (
            <SuggestionItem
              key={crypto.randomUUID()}
              role="option"
              onClick={() => (window.location.href = value)}
            >
              <SuggestionSearchIcon type="button" />

              <span>
                {highlights?.map(([type, value]) =>
                  type === "hit" ? (
                    <strong key={crypto.randomUUID()}>{value}</strong>
                  ) : (
                    value
                  )
                )}
              </span>
            </SuggestionItem>
          ))}
        </SuggestionContainer>
      )}
    </AutocompleteContainer>
  );
};

export default Autocomplete;
